import React, { FC } from "react";
import { ProductValidation } from "../product-validation";
import { IProductValidationDialog, ProductValidationDialog } from "./product-validation-dialog";

import { useIsPreviewMode } from "../../hooks/useIsPreviewMode";
import { useLabels } from "../../hooks/useLabels";
import { showDialogAsync } from "../dialog-queue";
import { IProductValidationContainer } from "../product-validation/product-validation-container";
import { labels } from "./labels";

type IProductValidationDialogContainer = Omit<IProductValidationDialog, "isError"> &
	Pick<IProductValidationContainer, "messages">;

const ProductValidationDialogContainer: FC<IProductValidationDialogContainer> = ({
	onOk,
	onCancel,
	messages,
	...dialogProps
}) => {
	const isError = messages.some((m) => m.isError);

	const dialogLabels = isError ? labels.errorLabels : labels.warningLabels;

	const [[beforeMessage, afterMessage]] = useLabels([
		dialogLabels.messageLabels.beforeWarningsLabel,
		dialogLabels.messageLabels.afterWarningsLabel,
	]);

	const [, setIsPreviewMode] = useIsPreviewMode();
	const onCancelNew = () => {
		setIsPreviewMode(false);
		onCancel();
	};

	const onOkNew = () => {
		setIsPreviewMode(false);
		onOk();
	};

	return (
		<ProductValidationDialog
			isError={isError}
			onCancel={onCancelNew}
			onOk={onOkNew}
			{...dialogProps}
		>
			<p>{beforeMessage}</p>
			<ProductValidation
				messages={messages}
				onClick={onCancelNew} // When a warning is clicked, go back
				showDetails={false}
			/>
			<p>{afterMessage}</p>
		</ProductValidationDialog>
	);
};
ProductValidationDialogContainer.displayName = "ProductValidationDialogContainer";

export function showProductValidationDialogAsync(
	messages: eXpress.core.ValidationMessages[],
	nextStep?: "cart" | "preview",
) {
	return showDialogAsync<boolean>(({ resolve }, { isOpen }) => (
		<ProductValidationDialogContainer
			onCancel={() => resolve(false)}
			onOk={() => resolve(true)}
			messages={messages}
			isOpen={isOpen}
			nextStep={nextStep}
		/>
	));
}
